module.exports = __webpack_public_path__ + "static/media/file_not_found.fb1f67b3.png";